import React from 'react'
export interface HintProps {
    /**
     * Indicates whether the hint is an error or a helpful caption.
     */
    error?: boolean
    /**
     *  A string | React node to be rendered
     */
    children: React.ReactNode

    /**
     * This makes it possible to pass through additional props.
     */
    [propName: string]: any
}

export function Hint({ children, error, ...rest }: HintProps) {
    const helperClass = error ? 'text-state-error' : 'text-black'
    return (
        <p
            className={`mt-0.5 text-left text-xs  text-neutral-400 ${helperClass}`}
            {...rest}
        >
            {children}
        </p>
    )
}
